import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en/common.json';
import ta from './locales/ta/common.json';

// #1211: staff-facing CRM UI translation. Keys are the exact English label
// text used across the app (nav labels, common actions) rather than opaque
// i18n keys -- keySeparator:false so a label containing '.' or '/' (e.g.
// "WhatsApp Log (OTP/System)") is never split, and any string not yet in
// the resource files just falls back to itself via `t(label, label)`.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      ta: { common: ta },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ta'],
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'zeeful_crm_language',
    },
  });

export default i18n;
